export const __APP_NAME__ = "العالمية للابتوب"